import React from "react";
import { Helmet } from "react-helmet";
import Frame from "../shared/Frame";
import { useAccountID } from "../store/account";
import { useShowID } from "../store/show";

export default function YouTube() {
    const accountID = useAccountID();
    const showID = useShowID();
    return (
        <>
            <Helmet>
                <title>YouTube - Podtrac</title>
            </Helmet>
            <Frame src={`/__/${accountID}/youtube?showID=${showID}`} />
        </>
    );
}
